import Task from "../../../../../shared/lib/html5-software-library/src/ranj/util/executor/Task";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import SkinKey from "../../../../../shared/src/ranj/app/ui/SkinKey";
import SkinKeys from "../../../../../shared/src/ranj/app/ui/SkinKeys";
import SplashLoadScreenMediator from "../splash/SplashLoadScreenMediator";
import TutorialScreenMediator from "../tutorial/TutorialScreenMediator";
import EpisodeSelectionScreenMediator from "../episode-selection/EpisodeSelectionScreenMediator";
import EndScreenMediator from "../end/EndScreenMediator";
import TransitionScreenMediator from "../transition/TransitionScreenMediator";
import DialogScreenMediator from "../ngt/dialog/view/DialogScreenMediator";

export default class ConfigureDirectionalSkinsTask extends Task {

    /**
     * Configures asset library and skin mappings for LTR or RTL based on language direction
     * This task must run after InitLanguageTask so appModel.rtl is available
     * 
     * @param {AppModel} appModel 
     * @param {soma.Injector} injector 
     * @param {MediatorMap} mediatorMap
     */
    constructor(appModel, injector, mediatorMap) {
        super();

        /**
         * Helper function to map a skin to a mediator, mirroring _mapMediator pattern
         * @param {*} mediatorClass - The mediator class to map to
         * @param {*} skinClass - The skin class to map
         * @returns {SkinKey} The created skin key
         */
        const mapSkin = (mediatorClass, skinClass) => {
            const key = new SkinKey(skinClass);
            if (mediatorClass != null) {
                mediatorMap.map(key, mediatorClass);
            }
            return key;
        };

        this.execute = function (callback, progressCallback) {

            const isRTL = appModel.rtl;
            
            // Add the correct directional asset variants for main game and dialog assets
            const startupAssetGroups = injector.getValue("startupAssetGroups");
            
            if (isRTL) {
                startupAssetGroups.push("MainAssets_RTL", "DialogScenes_RTL");
            } else {
                startupAssetGroups.push("MainAssets", "DialogScenes");
            }
                       
            // Select & inject the correct lib objects based on language direction
            const SplashAssetsLib = isRTL ? lib.SplashAssets_RTL : lib.SplashAssets;
            const MainAssetsLib = isRTL ? lib.MainAssets_RTL : lib.MainAssets;
            const DialogScenesLib = isRTL ? lib.DialogScenes_RTL : lib.DialogScenes;

            injector.mapValue("splashAssets", SplashAssetsLib);
            injector.mapValue("gameAssets", MainAssetsLib);
            injector.mapValue("dialogSceneAssets", DialogScenesLib);
            
            // Map (directional variants of) screen skins
            SkinKeys.SPLASH_LOAD_SCREEN_SKIN = mapSkin(SplashLoadScreenMediator, SplashAssetsLib.SplashLoadScreenSkin);
            SkinKeys.TUTORIAL_SCREEN = mapSkin(TutorialScreenMediator, MainAssetsLib.TutorialScreenSkin);
            SkinKeys.EPISODE_SELECTION_SCREEN = mapSkin(EpisodeSelectionScreenMediator, MainAssetsLib.EpisodeSelectionScreenSkin);
            SkinKeys.END_SCREEN = mapSkin(EndScreenMediator, MainAssetsLib.EndScreenSkin);
            SkinKeys.TRANSITION_SCREEN = mapSkin(TransitionScreenMediator, MainAssetsLib.TransitionScreenSkin);
            SkinKeys.DIALOG_SCREEN_SKIN = mapSkin(DialogScreenMediator, MainAssetsLib.DialogScreenSkin);

            
            callback(this);
        }
    }

}